import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";

class ModalNotificationsLanguage extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    componentDidMount(){}

    _close(){
        this.props.setLang(false);
    }

    _set(){
        this.props.setLang(true);
    }

    _renderText(item) {
        return langRegister.get("modal-notificationslanguage", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          <img onClick={() => this._close()}
                               className={Styles.overlayCloseButton}
                               src={require("../../assets/images/close_icon.svg")}/>
                          <div>
                              <div className={Styles.overlayModalText}>
                                  <div className={Styles.overlayModalTextGreen}>{this._renderText("item_1")}</div><div><span className={Styles.overlayModalTextBold}>{this._renderText("item_2")}</span>&nbsp;{this._renderText("item_3")}</div>
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => this._close()}
                                   className={Styles.overlayModalButtonsItemButton}>
                                  {this._renderText("item_4")}
                              </div>
                          </div>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_5")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalNotificationsLanguage;


// WEBPACK FOOTER //
// ./src/components/modal-notificationslanguage/component.js